import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { SessionFlow } from 'services/api/entities';
import { getOriginURL } from 'services/helpers/urlOrigin';
import useStripeSession from './useStripeSession';

const useUpgradeAccountSession = () => {
  const { createUserPortalSession } = useStripeSession();

  const reactLocation = useLocation();
  const { location } = window;

  const createStripeSession = useCallback(
    (flowType: SessionFlow) => {
      const originUrl = getOriginURL(location.origin, reactLocation.pathname);
      const returnUrl = `${originUrl}`;
      const successUrl = `${originUrl}?success=true`;
      createUserPortalSession({ returnUrl, flowType, successUrl });
    },
    [location.origin, reactLocation.pathname, createUserPortalSession]
  );

  const create = () => createStripeSession(SessionFlow.UPDATE);

  return { create };
};

export default useUpgradeAccountSession;
